import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { SkeletonComp, SubSkeletonComp } from "./styles";

interface IProps {
  count?: number;
}

const CSkeleton = ({ count }: IProps) => {
  return (
    <SkeletonTheme baseColor="#202020" highlightColor="#444">
      {[...Array(count).keys()].map((item, index) => (
        <SkeletonComp key={index.toString()}>
          <Skeleton
            circle={true}
            style={{
              height: 45,
              width: 45,
            }}
          />
          <SubSkeletonComp
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              alignSelf: "flex-start",
              marginTop: 2,
              marginLeft: 5,
            }}
          >
            <Skeleton
              style={{
                height: 12,
                width: 150,
                borderRadius: 5,
              }}
            />
            <Skeleton
              style={{
                height: 16,
                width: 280,
                marginTop: 7,
                marginBottom: 15,
                borderRadius: 5,
              }}
            />
          </SubSkeletonComp>
        </SkeletonComp>
      ))}
    </SkeletonTheme>
  );
};

export default React.memo(CSkeleton);
